<script>
import { required, email } from 'vuelidate/lib/validators';
import { authFackMethods, notificationMethods } from '@/state/helpers';
import { showMessage } from '@/utils/messages';
import { regexPassword } from '@/utils/regex';

export default {
    data() {
        return {
            email: '',
            password: '',
            submitted: false,
            iconEye: 'fa fa-eye-slash',
            loading: false
        };
    },
    computed: {
        notification() {
            return this.$store ? this.$store.state.notification : null;
        }
    },
    created() {
        document.body.classList.add('auth-body-bg');
    },
    validations: {
        email: { required, email },
        password: {
            required,
            validate() {
                if (this.password && this.password.length < 255) {
                    if (regexPassword(this.password)) {
                        return true;
                    } else {
                        return false;
                    }
                }
                return true;
            }
        }
    },
    methods: {
        ...authFackMethods,
        ...notificationMethods,

        tryToLogIn() {
            this.submitted = true;
            this.$v.$touch();
            if (this.$v.$invalid || this.loading) return;
            this.loading = true;
            const { email, password } = this;
            if (email && password) {
                this.login({ email, password }).then(async (data) => {
                    if (data.code == 200) {
                        await this.profile();
                        const redirectUrl = localStorage.getItem('redirectAfterLogin');
                        localStorage.removeItem('redirectAfterLogin');
                        const publicPages = ['/login', '/register', '/forgot-password', '/reset-password'];
                        const isValidRedirect = redirectUrl && !publicPages.includes(redirectUrl.split('?')[0]);
                        if (isValidRedirect) {
                            this.$router
                                .push(redirectUrl)
                                .catch(() => {
                                    window.location.href = redirectUrl;
                                })
                                .then(() => {
                                    showMessage(data.code, this.$bvToast, 'ログインが完了しました。');
                                });
                        } else {
                            this.$router.push({ path: '/' }).then(() => {
                                showMessage(data.code, this.$bvToast, 'ログインが完了しました。');
                            });
                        }
                    } else {
                        showMessage(data.code, this.$bvToast, this.$t(data.message));
                    }
                    this.loading = false;
                });
            }
        },
        handleTriggerPass() {
            let pass = document.getElementById('userpassword');
            if (pass.type == 'password') {
                pass.type = 'text';
                this.iconEye = 'fa fa-eye';
            } else {
                pass.type = 'password';
                this.iconEye = 'fa fa-eye-slash';
            }
        }
    }
};
</script>

<template>
    <div>
        <div class="dragon-scene">
            <div class="cloud"></div>
            <div class="cloud"></div>

            <div class="dragon">
                <div class="wing wing--behind"></div>
                <div class="leg leg--behind"></div>
                <div class="body"></div>
                <div class="head">
                    <div class="mouth"></div>
                    <div class="eye"></div>
                </div>
                <div class="horn"></div>
                <div class="paws"></div>
                <div class="leg leg--front"></div>
                <div class="wing wing--front"></div>
            </div>

            <div class="cloud"></div>
            <div class="cloud"></div>
        </div>

        <div>
            <div class="container-fluid p-0" style="min-height: 100vh; position: relative; z-index: 1">
                <div class="row no-gutters">
                    <div class="col-lg-12">
                        <div class="authentication-page-content min-vh-100 d-flex align-items-center justify-content-end" style="padding-right: 10%">
                            <div class="d-flex align-items-center justify-content-center flex-wrap-reverse">
                                <div class="form-block_account">
                                    <div class="col-md-12 text-center mb-3">
                                        <img src="@/assets/images/logo-paldia-new.png" alt="Image" class="img-fluid" />
                                    </div>
                                    <div class="mb-4">
                                        <h3>ログイン <strong></strong></h3>
                                    </div>
                                    <form class="needs-validation" @submit.prevent="tryToLogIn" autocomplete="off">
                                        <div class="form-group first">
                                            <i class="ri-mail-line auti-custom-input-icon align-middle mr-1"></i>
                                            <label for="email"
                                                >ID
                                                <span class="text-danger">*</span>
                                            </label>
                                            <input
                                                type="email"
                                                v-model="email"
                                                class="form-control"
                                                id="email"
                                                placeholder="ID"
                                                :class="{ 'is-invalid': submitted && $v.email.$error }"
                                            />
                                            <div v-if="submitted && $v.email.$error" class="invalid-feedback">
                                                <span v-if="!$v.email.required">メールアドレスを入力してください。</span>
                                                <span v-if="!$v.email.email">メールアドレスの形式は正しくありません。</span>
                                            </div>
                                        </div>
                                        <div class="form-group last mb-4">
                                            <i class="ri-lock-2-line auti-custom-input-icon align-middle mr-1"></i>
                                            <label for="userpassword"
                                                >パスワード
                                                <span class="text-danger">*</span>
                                            </label>
                                            <div
                                                class="inputBox"
                                                :class="{
                                                    'is-invalid': submitted && $v.password.$error
                                                }"
                                            >
                                                <input
                                                    v-model="password"
                                                    type="password"
                                                    class="form-control"
                                                    id="userpassword"
                                                    placeholder="パスワード入力"
                                                    :class="{ 'is-invalid': submitted && $v.password.$error }"
                                                />
                                                <span @click="handleTriggerPass">
                                                    <i :class="iconEye" aria-hidden="true"></i>
                                                </span>
                                            </div>
                                            <div v-if="submitted && $v.password.$error" class="invalid-feedback">
                                                <span v-if="!$v.password.required"> パスワードを入力してください。</span>
                                                <span v-if="!$v.password.validate"
                                                    >パスワードは大文字、小文字、数字、特殊文字を含む8～32文字以内で入力してください。</span
                                                >
                                            </div>
                                        </div>

                                        <div class="d-flex mb-4 align-items-center">
                                            <router-link tag="a" to="/forgot-password" class="text-muted ml-auto">
                                                <span class=""><i class="mdi mdi-lock mr-1"></i> *パスワードを忘れた方</span>
                                            </router-link>
                                        </div>

                                        <div class="mt-4 text-center">
                                            <button class="btn btn-pill text-white btn-block btn-primary" type="submit">ログイン</button>
                                        </div>

                                        <div class="pb-5"></div>

                                        <!-- <span class="d-block text-center my-4 text-muted"> or sign in with</span> -->

                                        <!-- <div class="social-login text-center">
                                            <a href="#" class="facebook">
                                                <span class="icon-facebook mr-3"><i class="ri-facebook-circle-fill"></i></span>
                                            </a>
                                            <a href="#" class="twitter">
                                                <span class="icon-twitter mr-3"><i class="ri-twitter-fill"></i></span>
                                            </a>
                                            <a href="#" class="google">
                                                <span class="icon-google mr-3"><i class="ri-google-fill"></i></span>
                                            </a>
                                        </div> -->
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped lang="scss">
.inputBox {
    position: relative;
    & input {
        padding-right: 26px;
    }
    & span {
        position: absolute;
        right: 5px;
        top: 10px;
        cursor: pointer;
        &:hover {
            color: #505d69cf;
        }
    }
}

// Dragon Animation Styles
$bg: #97d4f0;
$bg-alpha: rgba($bg, 0.33);
$cloud: #d9e4ea;

$light: #d7d75c;
$main: #a1c052;
$dark: #4d5227;
$dark-alpha: rgba($dark, 0.25);

$lit: #f0d56f;
$secondary: #9678ae;
$shaded: #674290;

$unit: 80vmin;
$head-height: 0.125em;
$border: 0.005em;
$cloud-width: 5vmin;

.dragon-scene {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background: $bg;
    overflow: hidden;
    z-index: 0;
    display: flex;
    justify-content: center;
    align-items: center;
}

.dragon {
    position: relative;
    font-size: $unit;
    width: 1em;
    height: 0.6em;
    animation: dragon 4s ease-in-out alternate infinite both;

    div {
        position: absolute;
    }
}

.body {
    top: -0.15em;
    left: #{$head-height * 1.5};
    width: 0.625em;
    height: 0.625em;
    border-radius: 50%;
    background:
        radial-gradient(circle at 25% 67%, #{$dark-alpha} 0.01em, transparent 0.01em),
        radial-gradient(circle at 20% 55%, #{$dark-alpha} 0.015em, transparent 0.015em),
        radial-gradient(circle at 15% 62%, #{$dark-alpha} 0.02em, transparent 0.02em),
        radial-gradient(circle at 95% 67%, #{$bg-alpha} 5%, transparent 5%),
        /* Kind of cheating… */ radial-gradient(circle at 12.5% 95%, #{$light} 15%, transparent 15%),
        radial-gradient(circle at 66.7% 25%, transparent 50%, #{$main} 50%);
    box-shadow: inset #{$border} #{$border * -1} 0 #{$dark-alpha};
    clip-path: polygon(0% 0.225em, 100% 0.225em, 100% 100%, 0% 100%);
}

.head {
    width: #{$head-height * 2.5};
    height: $head-height;
    border-radius: #{$head-height * 0.5} #{$head-height * 0.25} #{$head-height * 0.5} #{$head-height * 0.5};
    background: linear-gradient(0deg, #{$main}, #{$main});
    box-shadow: inset #{$border * -1} #{$border * -1} 0 #{$dark-alpha};
    overflow: hidden;
    transform-origin: calc(100% - #{$head-height * 0.5}) #{$head-height * 0.5};

    &::after {
        // Nose
        content: '';
        position: absolute;
        top: 50%;
        left: #{$border * 2};
        width: #{$border * 2};
        height: #{$border * 2};
        border-radius: 50%;
        background-color: $dark;
        box-shadow: #{$border * 3} 0 0 #{$dark};
    }
}

.mouth {
    left: 0;
    top: 50%;
    width: 50%;
    height: #{$head-height * 0.25};
    border-width: $border;
    border-style: solid;
    border-color: transparent #{$dark} #{$dark} transparent;
    border-radius: 0 #{$head-height * 0.25} #{$head-height * 0.25} 0;
}

.eye {
    left: calc(50% + #{$head-height * 0.25});
    top: 25%;
    width: #{$head-height * 0.25};
    height: #{$head-height * 0.25};
    border-width: #{$border} #{$border} 0;
    border-style: solid;
    border-color: #{$dark} #{$dark} transparent #{$dark};
    border-radius: #{$head-height * 0.25} #{$head-height * 0.25} 0 0;
}

.horn {
    &::before {
        // Horn
        content: '';
        position: absolute;
        left: #{$head-height * 0.4};
        bottom: #{$head-height * -0.0625};
        width: 0;
        height: 0;
        border-width: 0 #{$head-height * 0.125} #{$head-height * 0.25} #{$head-height * 0.125};
        border-color: transparent transparent #{$lit} transparent;
        border-radius: 50%;
    }
}

.paws {
    left: #{$head-height * 0.75};
    top: #{$head-height * 1.5};

    &::before,
    &::after {
        content: '';
        position: absolute;
        width: $head-height;
        height: #{$head-height * 0.5};
        border-radius: #{$head-height * 0.5} 0 0 0;
        border-color: #{$light} transparent transparent #{$light};
        border-width: #{$head-height * 0.25} 0 0 #{$head-height * 0.25};
        transform-origin: right #{$head-height * 0.125};
        animation: paw 1s ease-in-out alternate infinite both;
    }

    &::before {
        left: 0.01em;
        top: 0.01em;
        border-color: #{$dark} transparent transparent #{$dark};
        animation-delay: -0.25s;
        z-index: -1;
    }

    &::after {
        border-color: #{$light} transparent transparent #{$light};
    }
}

.leg {
    width: #{$head-height * 0.5};
    height: #{$head-height * 1.5};
    border-radius: #{$head-height * 0.5} #{$head-height * 0.25} 0 #{$head-height * 0.5};
    box-shadow: inset #{$border} #{$border * -1} 0 #{$dark-alpha};
    transform-origin: center #{$head-height * 0.25};
    animation: leg 1s ease-in-out alternate infinite both;

    &--front {
        left: 52%;
        top: 67%;
        background: $light;
    }

    &--behind {
        left: calc(52% + 0.01em);
        top: calc(67% - 0.01em);
        background: $dark;
        animation-delay: -0.25s;
        z-index: -1;
    }

    &::before,
    &::after {
        content: '';
        position: absolute;
        bottom: -25%;
        background: inherit;
    }

    &::before {
        // Heel
        left: 100%;
        width: 50%;
        height: 50%;
        border-radius: 0 #{$head-height * 0.25} #{$head-height * 0.125} 0;
        box-shadow: inset #{$border * -1} #{$border * -1} 0 #{$dark-alpha};
    }

    &::after {
        // Foot
        right: 0;
        width: 150%;
        height: 17.5%;
        border-top-left-radius: #{$head-height * 0.25};
        box-shadow: inset #{$border} #{$border * -1} 0 #{$dark-alpha};
    }
}

.wing {
    width: 0.025em;
    height: 27.5%;
    border-radius: 0.025em 0 0.025em 0.025em;
    transform: skew(-10deg);
    transform-origin: left bottom;
    animation: wing 1s ease-in-out infinite alternate both;

    &--behind {
        left: 35%;
        bottom: 60%;
        background-color: $shaded;
    }

    &--front {
        left: calc(35% - 0.01em);
        bottom: calc(60% + 0.01em);
        background-color: $secondary;
    }

    &::before,
    &::after {
        content: '';
        position: absolute;
        left: 100%;
        border-bottom-right-radius: 0.025em;
    }

    &::before {
        top: 0.025em;
        width: 0.225em;
        height: 33%;
    }

    &--behind {
        animation-delay: -0.1s;
    }

    &--behind::before {
        background-color: $light;
        background-image: linear-gradient(
            to bottom,
            transparent calc(50% - #{$border/2}),
            #{$shaded} calc(50% - #{$border/2}),
            #{$shaded} calc(50% + #{$border/2}),
            transparent calc(50% + #{$border/2})
        );
        box-shadow: 0 0.025em 0 #{$shaded};
    }

    &--front::before {
        background-color: $lit;
        box-shadow: 0 0.025em 0 #{$secondary};
        background-image: linear-gradient(
            to bottom,
            transparent calc(50% - #{$border/2}),
            #{$secondary} calc(50% - #{$border/2}),
            #{$secondary} calc(50% + #{$border/2}),
            transparent calc(50% + #{$border/2})
        );
    }

    &::after {
        top: 0;
        width: 0.25em;
        height: 0.025em;
        background-color: inherit;
    }
}

.cloud {
    position: absolute;
    left: -0.3em;
    font-size: $unit;
    width: 0.3em;
    height: 0.1em;
    border-radius: 0.05em;
    background-color: $cloud;
    animation: cloud linear infinite;

    &::before {
        content: '';
        position: absolute;
        top: -33%;
        width: 0.1em;
        height: 0.1em;
        border-radius: inherit;
        background-color: inherit;
    }

    &:nth-of-type(1) {
        top: 15vh;
        animation-duration: 1.5s;

        &::before {
            left: 16.7%;
        }
    }

    &:nth-of-type(2) {
        top: 60vh;
        animation-duration: 1.75s;
        animation-delay: -0.75s;

        &::before {
            left: 50%;
        }
    }

    &:nth-last-of-type(2) {
        top: 45vh;
        animation-duration: 1.25s;
        animation-delay: -0.25s;

        &::before {
            left: 33%;
        }
    }

    &:nth-last-of-type(1) {
        top: 30vh;
        animation-duration: 2s;
        animation-delay: -1s;

        &::before {
            left: 42%;
        }
    }
}

@keyframes dragon {
    from {
        transform: translateX(#{$unit / 20 * -1});
    }
    to {
        transform: translateX(#{$unit / 20});
    }
}

@keyframes paw {
    from {
        transform: rotate(-10deg);
    }
    to {
        transform: rotate(-20deg);
    }
}

@keyframes leg {
    from {
        transform: rotate(-60deg);
    }
    to {
        transform: rotate(-85deg);
    }
}

@keyframes wing {
    from {
        transform: skew(-10deg) rotate(-10deg);
    }
    to {
        transform: skew(-10deg) rotate(10deg);
    }
}

@keyframes cloud {
    to {
        transform: translateX(calc(100vw + 0.3em));
    }
}

// Responsive adjustments
@media (max-width: 1200px) {
    .authentication-page-content {
        justify-content: center !important;
        padding-right: 0 !important;
    }
}

@media (max-width: 768px) {
    .authentication-page-content {
        justify-content: center !important;
        padding-right: 0 !important;
    }
}
</style>
